import { render, staticRenderFns } from "./SummaryAnalysis.vue?vue&type=template&id=825c2fb6&scoped=true"
import script from "./SummaryAnalysis.vue?vue&type=script&lang=js"
export * from "./SummaryAnalysis.vue?vue&type=script&lang=js"
import style0 from "./SummaryAnalysis.vue?vue&type=style&index=0&id=825c2fb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825c2fb6",
  null
  
)

export default component.exports